import Button from "@/components/Button";
import TableSection from "./components/TableSection";
import Modal from "@/components/Modal";
import { useEffect, useMemo, useState } from "react";
import Dropdown from "@/components/Dropdown";
import SelectImage from "@/components/SelectImage";
import getProductInteractor from "@/@core/interactor/product/get-product";
import getWarehouseInteractor from "@/@core/interactor/warehouse/get-warehouse.interactor";
// import EMPTY_IMAGE from "@/assets/icons/no-image-square.svg";
import { OptionItem } from "@/components/Dropdown/model";
import uploadStockExcelInteractor from "@/@core/interactor/batch-uploads/upload-stock-excel.interactor";
import "./style.scss";

const STOCK_STATUS_OPTIONS = [
  {
    label: "Lock",
    value: "lock",
  },
  {
    label: "Unlock",
    value: "unlock",
  },
];

const StockQuantity = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [product, setProduct] = useState<OptionItem>();
  const [productList, setProductList] = useState<OptionItem[]>([]);
  const [warehouse, setWarehouse] = useState<OptionItem>();
  const [warehouseList, setWarehouseList] = useState<OptionItem[]>([]);
  const [isInitialModal, setIsInitialModal] = useState(false);
  const [selectedCSV, setSelectedCSV] = useState<any>();
  const csvExtension = ["text/csv", "application/vnd.ms-excel"];
  const isErrorFile = useMemo(() => {
    return (
      (!selectedCSV || csvExtension.indexOf(selectedCSV?.type) === -1) &&
      isInitialModal
    );
  }, [selectedCSV]);
  const [isFetch, setIsFetch] = useState<boolean>(false);
  const [isRefetchStock, setIsRefetchStock] = useState(false);
  const [stockStatus, setStockStatus] = useState(STOCK_STATUS_OPTIONS[0]);

  useEffect(() => {
    if (showModal) {
      getProduct();
      getWareHouse();
      setIsInitialModal(false);

      setTimeout(() => {
        setIsInitialModal(true);
      }, 1000);
    }
  }, [showModal]);

  const getProduct = async () => {
    try {
      const response = await getProductInteractor({});

      const {
        data: { data },
      } = response;

      const temp: OptionItem[] = data.map((item) => ({
        label: item.name,
        value: item.id,
        desc: item.master_sku,
        // imgSrc: item.images.length
        //   ? `${process.env.REACT_APP_API_URL}/file/${item.images[0].path}`
        //   : EMPTY_IMAGE,
      }));

      setProductList(temp);
      setProduct(temp[0]);
    } catch (error: any) {
      setProductList([]);
    }
  };

  const getWareHouse = async () => {
    try {
      const response = await getWarehouseInteractor({});

      const {
        data: { data },
      } = response;

      const temp = data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setWarehouseList(temp);
      setWarehouse(temp[0]);
    } catch (error: any) {
      setWarehouseList([]);
    }
  };

  const onChangeFile = (e: any) => {
    setSelectedCSV(e?.target?.files[0]);
  };

  const onContinue = async () => {
    setIsFetch(true);
    try {
      const response = await uploadStockExcelInteractor({
        product_id: product?.value,
        warehouse_id: warehouse?.value,
        file: selectedCSV,
        is_lock: stockStatus.value === "lock" ? true : false,
      });

      const { status } = response;

      if (status === 200) {
        setIsRefetchStock(true);
        setShowModal(!showModal);
        setIsFetch(false);

        setTimeout(() => {
          setIsRefetchStock(false);
        }, 1000);
      }
    } catch (error: any) {
      setIsFetch(false);
    }
  };

  return (
    <>
      <div className="stock-quantity-page-wrapper">
        <div className="header-page">
          <div>
            <h1>Stock Quantity</h1>
            <span className="sub-title">Manage your quantity here.</span>
          </div>
          <div className="btn-wrapper">
            <Button
              label="Quantity"
              size="md"
              startIcon="plus"
              onClick={() => setShowModal(!showModal)}
            />
          </div>
        </div>
        <div className="divider" />
        <div className="content">
          <TableSection isRefetchStock={isRefetchStock} />
        </div>
      </div>
      {showModal && (
        <div className="stock-modal-wrapper">
          <Modal
            setIsOpen={() => setShowModal(!showModal)}
            type="stock"
            content={
              <div className="modal-content">
                <div className="header">
                  <span className="text-title">Add Stock</span>
                  <span className="text">
                    Choose the desired product from the available options below.
                  </span>
                </div>
                <div className="column">
                  <span className="label">Product</span>
                  <div className="input">
                    <Dropdown
                      placeHolder="Select for product"
                      value={product}
                      options={productList}
                      onChange={(e) => setProduct(e)}
                      disabled={false}
                      optionType="product-option"
                      width="592px"
                    />
                  </div>
                </div>
                <div className="column">
                  <span className="label">Warehouse</span>
                  <div className="input">
                    <Dropdown
                      placeHolder="Select warehouse"
                      value={warehouse}
                      options={warehouseList}
                      onChange={(e) => setWarehouse(e)}
                      disabled={false}
                      optionType="text-option"
                      width="592px"
                    />
                  </div>
                </div>
                <div className="column">
                  <div className="upload text-align">
                    <SelectImage
                      onChange={(e) => onChangeFile(e)}
                      disabled={false}
                      displayIcon={true}
                      desc=".csv-file"
                      width="592px"
                      isError={isErrorFile}
                      errorText="Selected file must be .CSV"
                    />
                  </div>
                </div>
                <div className="column">
                  <span className="label">Set Stock Status</span>
                  <div className="input">
                    <Dropdown
                      placeHolder="Select warehouse"
                      value={stockStatus}
                      options={STOCK_STATUS_OPTIONS}
                      onChange={(e) => setStockStatus(e)}
                      disabled={false}
                      optionType="text-option"
                      width="592px"
                    />
                  </div>
                </div>
              </div>
            }
            footer={
              <div className="stock-modal-btn-wrapper">
                <Button
                  type="secondary"
                  label="Cancel"
                  onClick={() => setShowModal(!showModal)}
                />
                <Button
                  type="primary"
                  label={isFetch ? "Uploading" : "Continue"}
                  disabled={!selectedCSV || isErrorFile || isFetch}
                  onClick={onContinue}
                />
              </div>
            }
          />
        </div>
      )}
    </>
  );
};

export default StockQuantity;
